import React, { useEffect, useState } from 'react'
import { deleteQuesion, loadTalentQuestions, saveQuestionssSortOrder } from '../../../utils/Network';
import { getDefaultName } from '../../../utils';
import TalentQuestionContent from '../../TalentQuestionContent';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

export default function TalentQuestionsWidget({ talentId }) {
    const [loadingId, setLoadingId] = useState(0);
    const [questions, setQuestions] = useState([]);
    const [selectedQuestionId, setSelectedQuestionId] = useState(null);
    const [showQuestionDialog, setShowQuestionDialog] = useState(false);

    const reloadQuestions = () => {
        if (!talentId) return;
        loadTalentQuestions(talentId).then((items) => {
            setQuestions(items || []);
        });
    };

    useEffect(() => {
        setSelectedQuestionId(null);
        setShowQuestionDialog(false);
        reloadQuestions();
    }, [talentId]);

    const handleDelete = (questionId, e) => {
        e.preventDefault();
        setLoadingId(questionId);
        deleteQuesion(questionId).then(() => {
            setLoadingId(0);
            if (selectedQuestionId === questionId) {
                setSelectedQuestionId(null);
            }
            reloadQuestions();
        });
    };

    const onDragEnd = (result) => {
        const { destination, source } = result;
        if (!destination || destination.index === source.index) return;

        const temp = [...questions];
        const [moved] = temp.splice(source.index, 1);
        temp.splice(destination.index, 0, moved);
        setQuestions(temp);
        saveQuestionssSortOrder(temp.map((item) => item.id));
    };

    const openAddDialog = () => {
        setSelectedQuestionId(null);
        setShowQuestionDialog(true);
    };

    const openEditDialog = (questionId) => {
        setSelectedQuestionId(questionId);
        setShowQuestionDialog(true);
    };

    const closeDialog = () => {
        setShowQuestionDialog(false);
        setSelectedQuestionId(null);
    };

    const handleSaved = () => {
        closeDialog();
        reloadQuestions();
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="d-flex justify-content-end mb-5">
                    <button type="button" className="btn btn-cm" onClick={openAddDialog}>
                        <i className="fa fa-plus"></i> 
                    </button>
                </div>
                <div className="cms-dark-box">
                    
                    <div className="box-body no-padding">
                        <DragDropContext onDragEnd={onDragEnd}>
                            <table className="table table-striped cms-list-table mb-0">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Weight</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <Droppable droppableId="talent-questions">
                                    {(dropProvided) => (
                                        <tbody ref={dropProvided.innerRef} {...dropProvided.droppableProps}>
                                            {questions.map((item, index) => (
                                                <Draggable key={item.id} draggableId={`${item.id}`} index={index}>
                                                    {(provided) => (
                                                        <tr
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            className={loadingId === item.id ? "loading" : ""}
                                                        >
                                                            <td>{getDefaultName(item.names)}</td>
                                                            <td>{item.weight}</td>
                                                            <td className="text-right">
                                                                <div className="btn-group cms-row-actions">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-default btn-sm cms-row-action-btn"
                                                                        onClick={() => openEditDialog(item.id)}
                                                                    >
                                                                        <i className="fa fa-edit"></i>
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-default btn-sm cms-row-action-btn cms-row-action-btn-danger"
                                                                        onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) handleDelete(item.id, e) }}
                                                                    >
                                                                        <i className="fa fa-trash"></i>
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {dropProvided.placeholder}
                                        </tbody>
                                    )}
                                </Droppable>
                            </table>
                        </DragDropContext>
                    </div>
                </div>
            </div>

            {showQuestionDialog && (
                <div className="modal fade in" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                           
                            <div className="modal-body">
                                <TalentQuestionContent
                                    key={`${talentId}-${selectedQuestionId || 'new'}`}
                                    callback={reloadQuestions}
                                    talent_id={talentId}
                                    question_id={selectedQuestionId}
                                    isModal={true}
                                    onClose={closeDialog}
                                    onSaved={handleSaved}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
